import { contentV1GetPresetDatasourceOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useSuspenseQuery } from '@antimatterhq/ui/hooks/queries/useSuspenseQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetDatasourcePreset = ({
  name = '',
  version,
}: {
  name: string | undefined | null;
  version?: number | undefined | null;
}) => {
  const { workspace } = useWorkspace();
  return useQuery({
    ...contentV1GetPresetDatasourceOptions({
      ...defaultOptions(),
      path: { workspace, name: name ?? '' },
      query: {
        ...(version ? { version } : {}),
      },
    }),
    enabled: !!workspace && !!name,
  });
};

export const useGetDatasourcePresetWithSuspense = ({
  name = '',
  version,
}: {
  name: string | undefined | null;
  version?: number | undefined | null;
}) => {
  const { workspace } = useWorkspace();
  return useSuspenseQuery({
    ...contentV1GetPresetDatasourceOptions({
      ...defaultOptions(),
      path: { workspace, name: name ?? '' },
      query: {
        ...(version ? { version } : {}),
      },
    }),
  });
};
